"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var NAMESPACE = '[DepoReact] ';
exports.STORES_NOT_AVAILABLE = function () {
    return NAMESPACE + 'No stores provided. Did you add a provider?';
};
exports.STORE_NOT_FOUND = function (storeName) {
    return NAMESPACE + ("Store \"" + storeName + "\" not found or provider not mounted");
};
exports.INVALID_ARGUMENT = function () {
    return NAMESPACE + "mapStateToProps argument should be a function";
};
//# sourceMappingURL=Errors.js.map